import React from 'react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Clock, AlertTriangle } from 'lucide-react';
import { formatTimeRemaining } from '@/lib/sessionTimeout';

interface SessionTimeoutWarningProps {
  remainingTimeMs: number;
  onExtendSession: () => void;
  onLogout: () => void;
  isVisible: boolean;
}

export const SessionTimeoutWarning: React.FC<SessionTimeoutWarningProps> = ({
  remainingTimeMs,
  onExtendSession,
  onLogout,
  isVisible,
}) => {
  if (!isVisible) return null;

  const timeText = formatTimeRemaining(remainingTimeMs);
  const isUrgent = remainingTimeMs < 60000; // Less than 1 minute

  return (
    <div className="fixed top-4 right-4 z-50 max-w-md">
      <Alert variant={isUrgent ? "destructive" : "default"} className="border-2 bg-background shadow-lg">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle className="flex items-center gap-2">
          <Clock className="h-4 w-4" />
          Session Timeout Warning
        </AlertTitle>
        <AlertDescription className="mt-2 space-y-3">
          <p>
            Your session will expire in <strong>{timeText}</strong> due to inactivity.
          </p>
          <div className="flex gap-2">
            <Button 
              onClick={onExtendSession}
              size="sm"
              className="flex-1"
            >
              Stay Logged In
            </Button>
            <Button 
              onClick={onLogout}
              variant="outline"
              size="sm"
              className="flex-1"
            >
              Logout Now
            </Button>
          </div>
        </AlertDescription>
      </Alert>
    </div>
  );
};